import React from 'react'
import { Card, CardActions, CardTitle, CardText } from 'material-ui-legacy/Card'

import { niceJoin } from '../../lib/formats'
import DeleteButton from '../UI/DeleteButton'
import EditButton from '../UI/EditButton'
import CloseButton from '../UI/CloseButton'

const AgencyCard = props => {
  // Data can be received either as agency or itemData.
  const agency = props.agency || props.itemData

  const { editCallback, deleteCallback, closeCallback } = props

  const {
    name,
    city,
    province,
    country,
    phone,
    address,
    postalCode,
    code
  } = agency.attributes

  return (
    <Card>
      <CardTitle title={name} subtitle={niceJoin([city, province, country])} />

      <CardText>
        {phone && (
          <p>
            <strong>Phone:</strong> {phone}
          </p>
        )}
        {address && (
          <p>
            <strong>Address:</strong> {address}
          </p>
        )}
        {city && (
          <p>
            <strong>City:</strong> {city}
          </p>
        )}
        {province && (
          <p>
            <strong>State/Province:</strong> {province}
          </p>
        )}
        {country && (
          <p>
            <strong>Country:</strong> {country}
          </p>
        )}
        {postalCode && (
          <p>
            <strong>Postal code:</strong> {postalCode}
          </p>
        )}
        {code && (
          <p>
            <strong>Legacy code:</strong> {code}
          </p>
        )}
      </CardText>

      <CardActions>
        {editCallback && <EditButton onTouchTap={editCallback} />}
        {deleteCallback && (
          <DeleteButton
            onTouchTap={deleteCallback}
            confirmMessage={
              <p>
                Are you sure you want to delete <strong>{name}</strong>? There's
                no undo.
              </p>
            }
          />
        )}
        {closeCallback && <CloseButton onTouchTap={closeCallback} />}
      </CardActions>
    </Card>
  )
}

export default AgencyCard



// WEBPACK FOOTER //
// ./src/components/Agencies/AgencyCard.jsx